import slugify from 'slugify';

export const toUrlSlug = (input) => {
  return slugify(input, {
    replacement: '-', // replace spaces with -
    lower: true, // convert to lower case
    strict: true, // strip special characters except replacement
    trim: true, // trim leading/trailing replacement chars
  });
};

export const transformUrlSlugToTitle = (urlSlug) => {
  const lastSegment = urlSlug.split('/').filter(Boolean).pop(); // Get the last segment separated by "/"
  return lastSegment
    .split('-') // Split by hyphens
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(' '); // Join with spaces
};

export const removeParentSlug = (urlSlug, parentSlug) => {
  if (!parentSlug) return urlSlug.replace(/^\/+|\/+$/g, ''); // fallback: just trim slashes

  // Escape regex special characters in parentSlug
  const escapedParentSlug = parentSlug.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return urlSlug.replace(new RegExp(`^${escapedParentSlug}(\\/|$)|^\\/|\\/$`, 'g'), '');
};

export const getQueryParam = (param) => {
  return new URLSearchParams(window.location.search).get(param);
};

export const getParentSlugParam = () => {
  return getQueryParam('parent_slug') || null;
};

export const getCurrentSlugParam = () => {
  return getQueryParam('current_slug') || null;
};

export const getParentCategoryValueParam = () => {
  return getQueryParam('parent_category_value') || null;
};

export const sanitiseSlug = (slug) => (slug === '/' ? '/' : slug?.replace(/^\/+|\/+$/g, '') || null);

export const containsTemplateStrings = (urlSlug) => {
  return /\{\{(\w+)\}\}/.test(urlSlug);
};

export const extractTemplateStrings = (urlSlug) => {
  const matches = urlSlug.match(/\{\{(\w+)\}\}/g);
  return matches ? matches.map((match) => match.slice(2, -2)) : [];
};

export const replaceTemplateStringsFromArray = (urlSlug, replacementArray, categories = []) => {
  if (!urlSlug || typeof urlSlug !== 'string' || !Array.isArray(replacementArray)) {
    return urlSlug;
  }

  // Build a map for quick lookup of category values by category id
  const categoryMap = {};
  categories.forEach((cat) => {
    categoryMap[cat.id] = cat.values.reduce((acc, val) => {
      acc[val.id] = val.url_slug || toUrlSlug(val.name);
      return acc;
    }, {});
  });

  // Build a map for normal fields
  const valueMap = {};
  replacementArray.forEach((item) => {
    if (item.name && typeof item.value !== 'undefined') {
      // If it's a category field, resolve the name
      if (item.data_type === 'category' && item.value && categoryMap[item.foreign_category_id]) {
        valueMap[item.name] = categoryMap[item.foreign_category_id][item.value] || '';
      } else {
        valueMap[item.name] = item.value;
      }
    }
  });

  return urlSlug.replace(/\{\{(\w+)\}\}/g, (_, p1) => {
    return valueMap.hasOwnProperty(p1) ? valueMap[p1] : '';
  });
};
